<template>
  <div class="more">
    <div class="top">
      <div class="top__large">典型业绩展示</div>
      <div class="top__small">Typical Achievements</div>
    </div>
    <Breadcrumb style="margin: 20px 10%;font-size: 18px;">
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem to="/projectList">项目展示</BreadcrumbItem>
      <BreadcrumbItem>典型业绩展示</BreadcrumbItem>
    </Breadcrumb>

    <span class="title" id="ana">工程结构仿真-典型业绩展示</span>

    <ul class="lists">
      <li v-for="(item,index) in anaList" :key="index">
        <img :src="item.img" alt="">
        <span>{{item.title}}</span>
      </li>
    </ul>
    
    <span class="title" id="moni">工程智能监测-典型业绩展示</span>

    <ul class="lists">
      <li v-for="(item,index) in moniList" :key="index">
        <img :src="item.img" alt="">
        <span>{{item.title}}</span>
      </li>
    </ul>

    <span class="title" id="tech">工程数字科技-典型业绩展示</span>

    <ul class="lists">
      <li v-for="(item,index) in techList" :key="index">
        <img :src="item.img" alt="">
        <span>{{item.title}}</span>
      </li>
    </ul>

    <!-- <span class="title" id="dev">工程结构研发-典型业绩展示</span>

    <ul class="lists">
      <li v-for="(item,index) in devList" :key="index">
        <img :src="item.img" alt="">
        <span>{{item.title}}</span>
      </li>
    </ul> -->
  </div>
</template>
<script>
export default {
   name: 'projectList_detail',
   components: {
     
   },
   data() {
     return {
      anaList: [
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_analyse/万龙.jpg',
          title: '广州市万龙跨海工程主桥抗震分析与试验研究'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_analyse/东莞滨海湾大桥.jpg',
          title: '东莞滨海湾新区滨海湾大桥工程结构仿真分析'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_analyse/佛山市塘西大道三期.jpg',
          title: '佛山市塘西大道三期南延线工程结构仿真分析'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_analyse/虎门二桥.jpg',
          title: '虎门二桥悬索桥抗震与减震参数优化'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_analyse/广州番禺大桥.jpg',
          title: '广州番禺大桥工程仿真分析'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_analyse/佛山西江特大桥.jpg',
          title: '佛山富龙西江特大桥工程结构仿真分析研究'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_analyse/汕头牛田洋大桥.jpg',
          title: '汕头牛田洋快速通道工程抗震性能及减震措施研究'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_analyse/重庆鹅公岩大桥.jpg',
          title: '重庆市鹅公岩轨道专用桥工程抗震、结构仿真分析研究'
        }
      ],
      moniList: [
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_monitor/宝安体育馆.jpg',
          title: '深圳市宝安体育馆结构施工监控与健康监测服务'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_monitor/大疆.jpg',
          title: '大疆天空之城结构施工监控与运营健康监测服务'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_monitor/广州体育馆.jpg',
          title: '广州体育馆钢结构屋架监测'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_monitor/广州圆.jpg',
          title: '广州市广州圆施工第三方监测'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_monitor/鹤洞大桥.jpg',
          title: '广州市鹤洞大桥健康监测'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_monitor/华阳.jpg',
          title: '佛山市华阳特大桥运营期结构健康监测系统实施'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_monitor/汇德大厦.jpg',
          title: '汇德大厦1#楼主体结构监测'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_monitor/江门船厂.jpg',
          title: '江门市船厂跨江桥梁施工监控、运营过程健康监测服务'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_monitor/金融城.jpg',
          title: '金融城站综合交通枢纽PPP项目钢屋盖施工第三方监测'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_monitor/礼乐河.jpg',
          title: '江门市礼乐河大桥施工监控'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_monitor/龙湾.jpg',
          title: '佛山市龙湾大桥长期健康监测系统实施'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_monitor/顺德水道.jpg',
          title: '佛山市顺德水道特大桥结构健康监测'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_monitor/新光.jpg',
          title: '广州市新光大桥健康监测'
        }
      ],
      techList: [
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_technology/longwan.png',
          title: '佛山市龙湾大桥长期健康监测平台开发'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_technology/huayang.jpg',
          title: '佛山市华阳特大桥运营期结构健康监测平台开发'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_technology/xinguang1.jpg',
          title: '广州市新光大桥健康监测平台开发(1期)'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_technology/xg.jpg',
          title: '广州市新光大桥健康监测平台开发(2期)'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_technology/shunde.png',
          title: '佛山市顺德水道特大桥结构健康监测平台开发'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_technology/zhongshan.jpg',
          title: '中山市地方公路桥梁健康监测平台开发'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_technology/dj.jpg',
          title: '大疆天空之城结构施工监控与运营健康监测平台开发'
        },
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_technology/hd.jpg',
          title: '广州市鹤洞大桥健康监测平台开发'
        }
      ],
      devList: [
        {
          img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/project_dev/bim.jpg',
          title: '面向区域级结构健康监测与安全评估的CLOUD-BIM决策支持平台关键技术研究'
        },
      ],
     }
   },
   computed: {
     
   },
   created() {
    this.$emit('changeProduce','projectList_detail')
   },
   mounted() {
    let id = this.$route.params.id
    if(id){
      let position = document.querySelector('#'+id).offsetTop
      window.scrollTo({ top:position, left: 0, behavior: "smooth" })
      this.$route.params.id = null
    }
   },
   methods: {
     
   }
};
</script>
<style lang='less' scoped>
.more{
  width: 100%;
  .top {
    width: 100%;
    height: 280px;
    background: url("https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ache_banner.png")
      center center no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-weight: bold;
    color: #fff;
    // padding-left: 210px;
    &__large {
      font-size: 40px;
      line-height: 1.5em;
      margin-left: 210px;
    }
    &__small {
      font-size: 23px;
      line-height: 1.2em;
      margin-left: 210px;
    }
  }
  
  .title {
    display: block;
    width: 13em;
    margin: 48px auto 40px;
    position: relative;
    font-size: 24px;
    line-height: 1.5em;
    font-weight: bold;
    color: #000;
    text-align: center;
  }
  .title::after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 2em;
    height: 8px;
    background-color: #FAAD14;
  }

  .lists{
    display: flex;
    flex-direction: row;
    width: 1280px;
    margin: 0 auto;
    padding-bottom: 30px;
    flex-wrap: wrap;
    justify-content: flex-start;
    li{
      list-style: none;
      width: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 10px;
      font-size: 16px;

      img{
        width: 100%;
        height: 200px;
        display: block;
      }
      span{
        margin: 10px 0 0;
        width: 100%;
        // white-space: no-wrap;
        // overflow: hidden;
        // text-overflow: ellipsis;
        line-height: 1.5em;
        text-align: center;
      }
    }
  }
}
</style>